import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {combineLatest, Subscription} from 'rxjs';
import {UtilsService} from '../../../core/utils/utils.service';
import {UniteDeProductionDTO} from '../../../core/dtos/unite-de-production-dto';
import {UdpRepasPonderationDto} from '../../../core/dtos/unite-de-production/udp-repas-ponderation-dto';
import {GestionUniteProduction__RepasPonderationService} from '../../../core/services/gestion-unites-productions/gestion-unite-production__repas-ponderation.service';
import {ResponseWrapper} from '../../../core/suppliers/wrappers/response-wrapper';
import {MSG_KEY, MSG_SEVERITY} from '../../../core/constants';
import {ToastService} from '../../../core/services/technique/toast.service';
import {ButtonThemeEnum} from '../../../shared/ui/button/button-theme-enum';

@Component({
  selector: 'yo-up-repas-ponderation',
  templateUrl: './up-repas-ponderation.component.html',
  styleUrls: ['./up-repas-ponderation.component.scss'],
  standalone: false
})
export class UpRepasPonderationComponent implements OnInit, OnDestroy {

  public readonly ButtonThemeEnum = ButtonThemeEnum;

  subRoute: Subscription;
  saveSub: Subscription;

  uniteProduction: UniteDeProductionDTO;
  repasPonderationList: UdpRepasPonderationDto[] = [];

  constructor(
    private route: ActivatedRoute,
    private utils: UtilsService,
    private repasPonderationSvc: GestionUniteProduction__RepasPonderationService,
    private toastSvc: ToastService
  ) {}

  ngOnInit(): void {
    this.initData();
  }

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subRoute);
    this.utils.unsubscribe(this.saveSub);
  }

  initData = (): void => {
    this.subRoute = combineLatest([this.route.parent.data]).subscribe(data => {
      this.uniteProduction = data[0].uniteDeProductionSupplier.uniteDeProduction;
      this.loadRepasPonderation();
    });
  }

  loadRepasPonderation = (): void => {
    this.repasPonderationSvc.findByIdUdp(this.uniteProduction.id).subscribe((response: ResponseWrapper<UdpRepasPonderationDto>) => {
      this.repasPonderationList = response.resultList || [];
    });
  }

  onPonderationChange = (item: UdpRepasPonderationDto, value: number): void => {
    item.ponderation = value;
  }

  save = (): void => {
    this.saveSub = this.repasPonderationSvc.saveList(this.repasPonderationList).subscribe((response: ResponseWrapper<UdpRepasPonderationDto>) => {
      this.repasPonderationList = response.resultList || [];
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Les pondérations de repas ont été enregistrées avec succès`);
    });
  }

}
